var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { akinon: _vm.akinonEnabled },
      attrs: { id: "storyList" },
      on: { paste: _vm.handlePaste },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "side-menubar-wrapper" },
            [_c("SideMenuBar")],
            1
          ),
          _vm._v(" "),
          !_vm.modalVisible
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "big-title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.allSecnario"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stories" },
                  [
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["chatbot.stories.create"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story story-add",
                            attrs: { md: "3" },
                            on: {
                              click: function () {
                                return (_vm.modalVisible = true)
                              },
                            },
                          },
                          [
                            _c("a-icon", {
                              staticStyle: { "font-size": "30px" },
                              attrs: { type: "plus-circle", theme: "filled" },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-large font-weight-bolder mt-2",
                                staticStyle: {
                                  "font-size": "20px",
                                  "letter-spacing": "2px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("chatbotv2.addBot")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loading
                      ? _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          _vm._l(3, function (skltn) {
                            return _c(
                              "div",
                              {
                                key: skltn,
                                staticClass: "story story-add mx-2 p-3",
                                staticStyle: { background: "white !important" },
                                attrs: { md: "3" },
                              },
                              [
                                _c("a-skeleton", {
                                  attrs: {
                                    active: true,
                                    paragraph: { rows: 3 },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._l(_vm.stories, function (story) {
                          return _c(
                            "div",
                            {
                              key: story.id,
                              staticClass: "story",
                              attrs: { md: "3" },
                              on: {
                                click: function ($event) {
                                  _vm.$router.push(
                                    "/chatbot/story/" +
                                      story.id +
                                      "/" +
                                      _vm.getDraftVersion(story)
                                  )
                                },
                              },
                            },
                            [
                              _vm.getValueOfIntegrations(story).includes(true)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "ribbon w-100 m-2",
                                      on: {
                                        click: function (e) {
                                          e.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("chatbotv2.integratedWith")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          _vm._l(
                                            _vm.getKeysOfIntegrations(story),
                                            function (item, index) {
                                              return _c(
                                                "span",
                                                [
                                                  item === "supsisWidget" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("SupsisIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          content:
                                                            "Supsis Widget",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "whatsapp" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("WhatsappIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          specialBackgroundMode: true,
                                                          content: "Whatsapp",
                                                          color: "#28AC01",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "whatsappBusiness" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c(
                                                        "WhatsappBusinessIcon",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            specialBackgroundMode: true,
                                                            content:
                                                              "Whatsapp Business API",
                                                            color: "#28AC01",
                                                          },
                                                        }
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "instagram" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("InstagramIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          specialBackgroundMode: true,
                                                          content: "Instagram",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "telegram" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("TelegramIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          specialBackgroundMode: true,
                                                          content: "Telegram",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "facebook" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("FacebookIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          content: "Facebook",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "twitter" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("TwitterIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          content: "Twitter",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "slack" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("SlackIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          content: "Slack",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "skype" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("SkypeIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          content: "Skype",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item === "shopify" &&
                                                  _vm.getValueOfIntegrations(
                                                    story
                                                  )[index] === true
                                                    ? _c("ShopifyIcon", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "top-center",
                                                            },
                                                            expression:
                                                              "{ followCursor: true, placement: 'top-center' }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "integration-icons pt-2",
                                                        attrs: {
                                                          content: "Shopify",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-popover",
                                {
                                  staticClass: "story-menu-content px-3",
                                  attrs: {
                                    id: "story-menu-popover",
                                    trigger: "focus",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "story-menu-popover-items",
                                          on: {
                                            click: function ($event) {
                                              _vm.$router.push(
                                                "/chatbot/story/" +
                                                  story.id +
                                                  "/" +
                                                  _vm.getDraftVersion(story)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("a-icon", {
                                                staticClass: "px-1",
                                                attrs: { type: "edit" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.edit"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          "margin-bottom": "0.2rem",
                                          "margin-top": "0.2rem",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "story-menu-popover-items",
                                          on: {
                                            click: function ($event) {
                                              return _vm.duplicateAStory(story)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("a-icon", {
                                                staticClass: "px-1",
                                                attrs: { type: "switcher" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.duplicate")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          "margin-bottom": "0.2rem",
                                          "margin-top": "0.2rem",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.checkPermission(
                                        _vm.PERMISSION_TYPES[
                                          "chatbot.stories.delete"
                                        ].tr.name
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "story-menu-popover-items",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showDeleteConfirmation(
                                                    story
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("a-icon", {
                                                    staticClass: "px-1",
                                                    attrs: { type: "delete" },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.delete")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          "margin-bottom": "0.2rem",
                                          "margin-top": "0.2rem",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      staticClass: "chatbot-btn",
                                      staticStyle: {
                                        "margin-left": "auto",
                                        "font-weight": "bolder",
                                        "letter-spacing": "2px",
                                        "font-size": "20px",
                                      },
                                      on: {
                                        click: function (e) {
                                          return e.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(story.name) +
                                          "\n                            ...\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column justify-content-between px-3 graph-alignment",
                                },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(story.title)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$_.isEmpty(story.description)
                                    ? _c("span", [
                                        _vm._v(_vm._s(story.description)),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "top-center",
                                              },
                                              expression:
                                                "{ followCursor: true, placement: 'top-center' }",
                                            },
                                          ],
                                          staticClass:
                                            "description text-shorten",
                                          attrs: { content: story.description },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(story.description) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("ECharts", {
                                    staticClass: "echart-graph",
                                    attrs: {
                                      option: _vm.lineBar(
                                        story.meta.last7DaysUsages
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["chatbot.templates.view"].tr.name
                )
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.modalVisible,
                            expression: "!modalVisible",
                          },
                        ],
                        staticClass: "section-templates",
                        class: { akinon: _vm.akinonEnabled },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "section-templates-header" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "section-templates-header-text",
                                attrs: {
                                  "text-type": "h2",
                                  "text-weight": "semi-bold",
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" tips_and_updates "),
                                ]),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t("message.useReadyTemplates")
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary", ghost: "" },
                                on: { click: _vm.gotoTemplatePage },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("message.checkMore")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("Templates", {
                          attrs: {
                            "show-search": false,
                            "show-side-bar": false,
                            "enabled-slugs": _vm.akinonEnabled
                              ? ["us-polo-assn", "pierre-cardin", "cacharel"]
                              : [
                                  "online-quiz-bot",
                                  "call-scheduling",
                                  "university-bot",
                                ],
                            "page-mode": false,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["chatbot.aitemplates.view"].tr.name
                ) && !_vm.modalVisible
                  ? _c(
                      "div",
                      { staticClass: "section-templates" },
                      [
                        _c(
                          "div",
                          { staticClass: "section-templates-header" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "section-templates-header-text",
                                attrs: {
                                  "text-type": "h2",
                                  "text-weight": "semi-bold",
                                },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "30px",
                                    height: "30px",
                                  },
                                  attrs: {
                                    src: "/static/img/chatbot/genie.svg",
                                  },
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("message.useAITemplates")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary", ghost: "" },
                                on: { click: _vm.gotoAITemplatePage },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("message.checkMore")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("AITemplates", {
                          attrs: {
                            "show-search": false,
                            "show-side-bar": false,
                            "enabled-slugs": [
                              "gpt3-english-translator",
                              "gpt3-it-expert",
                              "gpt3-Football-Commentator",
                              "gpt3-relationship-coach",
                            ],
                            "page-mode": false,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.modalVisible
        ? _c("CreateChatbot", {
            on: {
              close: function () {
                return (_vm.modalVisible = false)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }